<template>
    <form @submit.prevent="sign">
        <label>Personnummer (12 siffror utan bindestreck)</label>
        <input type="text" inputmode="numeric" placeholder="12 siffror" class="form-control" required pattern="\d{12}" v-model="pno">

        <div v-if="isLocalhost" class="my-5">
            <h6>DEBUG</h6>
            <p>Item ID: {{itemId}}</p>
            <p>Item Description: {{itemDescription}}</p>
        </div>

        <button v-if="!authenticating" type="submit" class="signatureComponentSignButton btn btn-secondary mt-3">
            {{ signatureButtonLabel }}
        </button>
        <button v-else type="button" class="signatureComponentSignButton btn btn-primary mt-3 wait">
            <div class="spinner-border spinner-border-sm mr-2"></div> Öppna Bank-ID på din telefon
        </button>
    </form>
</template>

<style lang="scss" scoped>
button {
    width: 100%;

    &.wait .spinner-border {
        vertical-align: middle;
    }
}
</style>

<script setup>
import axios from "axios";
import { computed, onBeforeUnmount, ref } from "vue";

// Props should be in sync with onScreenSign.vue
const props = defineProps({
    itemId: { type: String, default: undefined },
    itemDescription: { type: String, default: undefined },
    appUrl: { type: String, default: undefined },
    redirectOnSignedUrl: { type: String, default: undefined },
    signeeName: { type: String, default: null },
    signatureButtonLabel: { type: String, default: undefined },
});
const emit = defineEmits(["signed"]);

const pno = ref(null);
const authenticating = ref(false);
const verifyTimer = ref(null);

const isLocalhost = computed(() => document.location.hostname === "localhost");

async function sign() {
    const requestHeaders = new Headers();
    requestHeaders.append("Content-Type", "application/json");

    const requestBody = JSON.stringify({
        itemId: props.itemId,
        itemDescription: props.itemDescription,
        pno: pno.value,
        ipAddress: "213.136.48.244", // TODO: Why is this hardcoded?
        callbackUrl: `${props.appUrl}/auth/verify`,
    });

    const requestUrl =
        "https://liveapi03.idkollen.se/api/seal-service/8d846efd-bb84-11ea-9758-067809246251/sign-item";
    const requestOptions = {
        method: "POST",
        headers: requestHeaders,
        body: requestBody,
        redirect: "follow",
    };

    try {
        authenticating.value = true;
        const response = await fetch(requestUrl, requestOptions);

        if (response.status >= 200 && response.status < 300) {
            verifyTimer.value = setInterval(() => verifySignature(), 3000);
        } else {
            throw response;
        }
    } catch (error) {
        authenticating.value = false;
        console.log("error", error);
    }
}

async function verifySignature() {
    try {
        const response = await axios.get("/auth/control/" + pno.value);

        if (response.status === 200) {
            stopVerification();

            if (props.redirectOnSignedUrl) {
                window.location.replace(props.redirectOnSignedUrl);
            } else {
                emit("signed");
            }
        }
    } catch (error) {
        console.warn("Failed to verify BankID signature.", error);
    }
}

function stopVerification() {
    clearInterval(verifyTimer.value);
    verifyTimer.value = null;
}

onBeforeUnmount(stopVerification);
</script>
